import dynamic from 'next/dynamic'

export const DynamicRewardsDrawer = dynamic(() => import('.').then((mod) => mod.RewardsDrawer), {
  ssr: false,
})
